export const beginAuthentication = (eventListener) => {
  window.removeEventListener('message', eventListener);
  let url = '/api/User/AuthorizeGoogle';
  const strWindowFeatures = 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100';
  const newWindow = window.open(url, '_blank', strWindowFeatures);
  newWindow.focus();
  window.addEventListener('message', event => eventListener(event), false);
}